import React, { useState, useEffect } from "react";
import Tabela from '../../components/data/Tabela'
import useAxios from "../../helpers/useAxios";
import Collapse from 'react-bootstrap/Collapse';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { subtractDaysDate, getCurrentDate, formatDateService } from "../../helpers/utils.js";
import { pt } from "date-fns/locale";
import 'react-datepicker/dist/react-datepicker.css';

const Movimentos = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [order, setOrder] = useState("desc");
  const [isLoaded, setIsLoaded] = useState(false);

  const { fetch, data, error, loaded } = useAxios("POST", "/Funds/funds-moviments", {
      nif: props.nif,
      id: parseInt(props.id),
      initialDate: formatDateService(startDate),
      endDate: formatDateService(endDate),
      order: order,
  });

  useEffect(() => {
    setIsLoaded(false);

    fetch("POST", "/Funds/funds-moviments", {
      nif: props.nif,
      id: parseInt(props.id),
      initialDate: formatDateService(startDate),
      endDate: formatDateService(endDate),
      order: order,
  });
  }, [props.id]);

  useEffect(() => {
    if (loaded && error.length === 0)
      setIsLoaded(true);
  }, [data]);

  const columns = [
    { id: 'data', name: "Data", },
    { id: 'tipo', name: "Tipo de operação", },
    { id: 'unitAssociado', name: "Unidades associado", align: "right", type: "up", },
    { id: 'unitParticipante', name: "Unidades participante", align: "right", type: "up", },
    { id: 'cotacaoUP', name: "Cotação UP", align: "right", type: "money", },
    { id: 'montante', name: "Montante", align: "right", type: "money", },
  ];

  function imgToBase64(url, callback) {
    if (!window.FileReader) {
      callback(null);
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    
    xhr.onload = function() {
      var reader = new FileReader();
      
      reader.onloadend = function() {
        callback(reader.result.replace('text/xml', 'image/jpeg'));
      };
      
      reader.readAsDataURL(xhr.response);
    };

    xhr.open('GET', url);
    xhr.send();
  }

  var base64Img;
  imgToBase64("./email-header.png", function(base64) {
    base64Img = base64;
  });

  const downloadData = (moviments) => {
    var rowsPdf = Object.values(moviments).map(m => [m.data, m.tipo, m.unitAssociado + ' UPs', m.unitParticipante + ' UPs', m.cotacaoUP + ' €', m.montante + ' €']);

    const doc = new jsPDF({
      orientation: 'portrait',
      format: 'a4',
			unit: 'px',
		});

    var totalPagesExp = '{total_pages_count_string}';

    autoTable(doc, {
      head: [
        [
          { content: props.name, colSpan: 6, styles: {fontSize: 12, fontStyle: 'normal', fillColor: [255, 255, 255], textColor: [0, 0, 0]} },
        ],
        [
          { content: 'Data', styles: {fillColor: [0, 113, 206]} }, 
          { content: 'Tipo de operação', styles: {fillColor: [0, 113, 206]} },
          { content: 'Unidades associado', styles: {halign: 'right', fillColor: [0, 113, 206]} },
          { content: 'Unidades participante', styles: {halign: 'right', fillColor: [0, 113, 206]} },
          { content: 'Cotação UP', styles: {halign: 'right', fillColor: [0, 113, 206]} },
          { content: 'Montante', styles: {halign: 'right', fillColor: [0, 113, 206]} },
        ]
      ], 
      body: rowsPdf,

      margin: [40, 15, 110, 15], // [top, right, down, left]
      columnStyles: { 2: { halign: 'right' }, 3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' } },

      didParseCell: function (data) {      
        if(data.row.section === 'body') {
          if (data.row.index === 0) {
            data.cell.styles.fontStyle = 'bold';
          }
        }  
      },
      
      didDrawPage: function (data) {
        // Header
        doc.setFontSize(13);
        doc.setTextColor("#000000")

        if (base64Img) { 
          doc.addImage(base64Img, 'PNG', 200, 15, 30, 25);
        }   
        
        // Footer 
        var footerText = 'Página ' + doc.internal.getNumberOfPages();
        
        // Total page number plugin only available in jspdf v1.0+ 
        if (typeof doc.putTotalPages === 'function') { 
          footerText = footerText + ' de ' + totalPagesExp;
        } 
  
        // jsPDF 1.4+ uses getWidth, <1.4 uses .width 
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        
        doc.setFontSize(7);
        doc.setTextColor('#666666');
        doc.text("O valor da unidade de participação (UP) dos Fundos de Pensões evolui, em cada momento, em função do valor dos ativos integrantes da carteira do Fundo, pelo que pode aumentar ou diminuir, sendo o respetivo valor divulgado diariamente, nos dias úteis.", 15, pageHeight - 100, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("Os valores apresentados foram calculados com base nas UP diárias do Fundo, que refletem o potencial de valorização dos ativos subjacentes e o valor atual dos rendimentos futuros.", 15, pageHeight - 86, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("O valor da UP é líquido de comissões e impostos na esfera do Fundo, estando o investidor sujeito à aplicação das comissões contratualizadas, nomeadamente comissão de reembolso ou de subscrição caso tal se aplique, bem como à fiscalidade inerente a este produto a título de imposto sobre os rendimentos das pessoas singulares.", 15, pageHeight - 72, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("Os Fundos de Pensões encontram-se isentos de imposto sobre o rendimento, exceto na situação prevista no n.º11 do art.º 88.º do Código do IRC. Por regra, os participantes são tributados no momento do reembolso, por retenção na fonte.", 15, pageHeight - 58, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("Os Documentos Constitutivos dos Fundos de Pensões encontram-se disponíveis em na área: Extrato Individual > Informação sobre o Fundo.", 15, pageHeight - 44, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("Caso cesse o vínculo laboral, o valor associado aos direitos adquiridos poderá diferir do apresentado, de acordo com as regras do plano de Pensões.", 15, pageHeight - 37, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("Os valores apresentados são referentes à situação financeira específica do Participante.", 15, pageHeight - 30, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });
        doc.text("A CGD PENSÕES, Sociedade Gestora de Fundos de Pensões, S.A., não é responsável pela realização das contribuições a cargo do Associado.", 15, pageHeight - 23, { lineHeightFactor: 1.3, maxWidth: 410, align: "justify" });

        doc.setFontSize(9);
        doc.setTextColor("#000000")
        doc.text(footerText, 500, pageHeight - 10, 'right');
      }
    });

    // Total page number plugin only available in jspdf v1.0+ 
    if (typeof doc.putTotalPages === 'function') { 
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('extrato_' + props.id + '_' + getCurrentDate('-') + '.pdf');
  }

  return (
    <div className="col-md-12 bg-white rounded-4 p-3 mb-4">
      <div className="row">
        <div className="col-6 my-auto">
          <h3 className="my-auto">Últimos movimentos</h3>
        </div>
        <div className="col-6 text-end">
          <button type="button" className="btn btn-table me-3"
            onClick={() => setIsOpen(!isOpen)}
            >
              <div className="row">
                <div className="col-4">
                  <svg width="16px" height="16px" viewBox="0 0 1024 1024" className="me-1">
                    <g stroke="none" strokeWidth="1" fill="#3F5B78" fillRule="evenodd">
                      <path d="M554.666667 512a42.666667 42.666667 0 0 1 8.533333-25.6l256-341.333333a42.666667 42.666667 0 1 1 68.266667 51.2L640 526.208V768a42.666667 42.666667 0 0 1-23.594667 38.144l-170.666666 85.333333A42.666667 42.666667 0 0 1 384 853.333333v-327.125333L136.533333 196.266667A42.666667 42.666667 0 0 1 170.666667 128h512a42.666667 42.666667 0 0 1 0 85.333333H256l204.8 273.066667a42.666667 42.666667 0 0 1 8.533333 25.6v272.298667l85.333334-42.666667V512z" />
                    </g>
                  </svg>
                </div>
                <div className="col-8 ps-0" style={{marginTop:'2px'}}>Filtrar</div>
              </div>
          </button>
          <button type="button" className="btn btn-table"
            onClick={() => downloadData(data.lstMoviments)}
            >
              <svg width="16px" height="16px" viewBox="0 0 1024 1024">
                <g stroke="none" strokeWidth="1" fill="#3F5B78" fillRule="evenodd">
                  <path d="M896 928c0 17.664-14.336 32-32 32l-704 0C142.336 960 128 945.664 128 928l0 0C128 910.336 142.336 896 160 896l704 0C881.664 896 896 910.336 896 928L896 928zM479.104 96.896l0 558.976-153.6-153.664c-12.8-12.8-33.6-12.8-46.464 0s-12.8 33.6 0 46.464l209.664 209.728c0.64 0.64 1.408 0.832 2.048 1.344 2.624 2.304 5.376 4.416 8.64 5.76 3.648 1.408 7.36 2.112 11.2 2.24C511.104 767.68 511.488 768 512 768c0.768 0 1.344-0.448 2.048-0.448 3.584-0.192 7.04-0.768 10.496-2.048 3.84-1.6 7.232-3.968 10.176-6.784 0 0 0.32-0.192 0.512-0.32l209.664-209.728c6.4-6.4 9.6-14.784 9.6-23.168 0-8.448-3.264-16.832-9.6-23.232-12.864-12.8-33.6-12.8-46.464 0l-153.664 153.664 0.32-558.976C545.152 78.72 530.432 64 512.32 64S479.104 78.72 479.104 96.896z" />
                </g>
              </svg>
          </button>
        </div>
      </div>
      <Collapse in={isOpen}>
        <div className="mt-4">
          <div className="row">
            <div className="form-group col-4">
              <label>Ordenação</label>
              <select className="form-control" value={order} onChange={(e) => {
                  setOrder(e.target.value)
                }}>
                <option value="asc">Data ascendente</option>
                <option value="desc">Data descendente</option>
              </select>
            </div>
            <div className="form-group col-4">
              <label>Data de início</label>
              <DatePicker className="form-control" selected={startDate} dateFormat="dd/MM/yyyy" locale={pt} showYearDropdown minDate={new Date(2000, 0, 1)} maxDate={subtractDaysDate(new Date(), 1)} onChange={(date) => {
                  setStartDate(date);
                  //setEndDate(date);
                }} />
            </div>
            <div className="form-group col-4">
              <label>Data de fim</label>
              <DatePicker className="form-control" selected={endDate} dateFormat="dd/MM/yyyy" locale={pt} showYearDropdown minDate={startDate} maxDate={subtractDaysDate(new Date(), 1)} onChange={(date) => {
                  setEndDate(date);
                }} />
            </div>
          </div>
          <div className="row pt-4">
            <div className="col-12">
              <button type="submit" className="btn btn-primary btn-small me-3"
                onClick={() => {
                  setIsLoaded(false);

                  fetch("POST", "/Funds/funds-moviments", {
                    nif: props.nif,
                    id: props.id,
                    initialDate: formatDateService(startDate),
                    endDate: formatDateService(endDate),
                    order: order,
                  });
                }}>
                Mostrar resultados
              </button>
              <button type="button" className="btn btn-secondary btn-small"
                onClick={() => {
                  setOrder("desc");
                  setStartDate("");
                  setEndDate("");
                }}>
                Limpar filtro
              </button>
            </div>
          </div>
        </div>
      </Collapse>
      {!isLoaded && (
        <div className="text-center pt-4">
          <div className="spinner-border text-blue" role="status">
          </div>
        </div>
       )}
      {(isLoaded && error.length === 0) && (
        <Tabela columns={columns} rows={data.lstMoviments} viewSize={5} specialFirst={true} icon="M19.2520166,0 C22.003507,0 24,1.26339423 24,3.00389849 L24,14.1341691 C24,15.8746734 22.003507,17.1380676 19.2520166,17.1380676 C17.9694891,17.1889905 16.7029546,16.8328276 15.6260083,16.1183957 C14.5488798,16.8324121 13.2824764,17.1885381 12,17.1380676 C10.7174726,17.1889905 9.45093806,16.8328276 8.37399172,16.1183957 C7.2966257,16.8325837 6.02990222,17.1887171 4.74714175,17.1380676 C1.99649295,17.1380676 0,15.8746734 0,14.1341691 L0,6.7139887 C0,4.97434566 1.99480957,3.71095143 4.74714175,3.71095143 C7.49947394,3.71095143 9.49680859,4.97434566 9.49680859,6.7139887 L9.49680859,7.84389547 C10.301275,7.55571396 11.1485356,7.41263783 12.0008417,7.42104164 C12.8531399,7.41274249 13.700383,7.55581567 14.5048748,7.84389547 L14.5048748,3.00389849 C14.5048748,1.26339423 16.5013677,0 19.2528582,0 Z M7.25285825,13.0042624 C6.44814656,13.2927165 5.6006119,13.4360822 4.74798345,13.4279774 C3.89618054,13.4360621 3.04947862,13.2926927 2.24563372,13.0042624 L2.24563372,14.1341691 C2.97122025,14.666431 3.85827137,14.9170723 4.74798345,14.8412221 C5.6472458,14.9332222 6.54606446,14.6622065 7.25285825,14.0859414 Z M14.5048748,13.0042624 C13.7004379,13.292652 12.8531906,13.4360173 12.0008417,13.4279774 C11.1484849,13.436122 10.30122,13.2927538 9.49680859,13.0042624 L9.49680859,14.1341691 C10.2229129,14.6666902 11.1105808,14.9173371 12.0008417,14.8412221 C12.8998404,14.9331772 13.7983814,14.6621542 14.5048748,14.0859414 Z M21.7644666,13.0042624 C20.1384323,13.5708149 18.3748594,13.5708149 16.7488251,13.0042624 L16.7488251,14.1341691 C17.4749295,14.6666902 18.3625974,14.9173371 19.2528582,14.8412221 C20.7670618,14.8438057 21.6626219,14.2943541 21.7644666,14.0747457 Z M7.25959178,9.29158852 C6.45303095,9.5822224 5.60305802,9.72648945 4.74798345,9.71788719 C3.89618054,9.72597186 3.04947862,9.58260247 2.24563372,9.29417215 L2.24479203,10.4240789 C2.97037855,10.9563408 3.85742967,11.2069821 4.74714175,11.1311319 C6.25882023,11.1311319 7.15185523,10.5859863 7.25959178,10.3655167 Z M21.7644666,9.29417215 C20.1384323,9.86072469 18.3748594,9.86072469 16.7488251,9.29417215 L16.7488251,10.4206341 C17.4749295,10.9531551 18.3625974,11.203802 19.2528582,11.127687 C20.7704286,11.127687 21.6659886,10.5782354 21.7678333,10.358627 Z M12.2437987,9.70334619 L12.0042085,9.71444235 C11.1246594,9.64498024 10.2493349,9.89503472 9.53215964,10.4206341 C10.2491601,10.9466734 11.1245432,11.1970496 12.0042085,11.127687 C12.8836277,11.1972168 13.7588011,10.9468153 14.4754156,10.4206341 C13.758626,9.89489304 12.8835114,9.64481336 12.0042085,9.71444235 Z M21.7644666,5.5806371 C20.1384323,6.14718963 18.3748594,6.14718963 16.7488251,5.5806371 L16.7454584,6.71312749 C17.4717235,7.24530392 18.3592653,7.49591521 19.2494915,7.42018043 C20.7679035,7.42018043 21.6626219,6.8690064 21.7644666,6.65112041 Z M4.98764009,5.99674162 L4.74798345,6.00779697 C3.8686805,5.93816798 2.9935659,6.18824766 2.27677632,6.7139887 C2.99339079,7.24016991 3.86856425,7.49057141 4.74798345,7.42104164 C5.6276487,7.4904042 6.50303185,7.24002798 7.22003226,6.7139887 C6.502857,6.18838935 5.62753255,5.93833486 4.74798345,6.00779697 Z M19.2528582,2.29340071 C18.372749,2.22465888 17.4972041,2.47630146 16.7808094,3.00389849 C17.4974239,3.53007969 18.3725974,3.78048119 19.2520166,3.71095143 C20.1314358,3.78048119 21.0066092,3.53007969 21.7232237,3.00389849 C21.0066092,2.47771728 20.1314358,2.22731578 19.2520166,2.29684555 Z" />
      )}
    </div>
  );
};

export default Movimentos;